import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { COMPANY, fallbackContact, telHref, mailHref } from "@/lib/company";

export default function Impressum() {
  const { t } = useLanguage();
  const { content } = useContent();
  const contact = content?.contact ?? fallbackContact;
  const l = t.legal.impressum;
  const h2 = "text-xl font-semibold tracking-tight text-[#0A0A0A]";

  return (
    <div data-testid="impressum-page">
      <PageHeader overline="Legal" title={t.legal.impressumTitle} />
      <section className="bg-white">
        <div className="mx-auto max-w-3xl space-y-12 px-6 py-20 lg:px-10 lg:py-24">
          <Reveal>
            <h2 className={h2}>{l.companyHeading}</h2>
            <div className="mt-4 space-y-1 text-[#4A4A4A]">
              <p className="font-medium text-[#0A0A0A]">{COMPANY.name}</p>
              <p>{contact.street}</p>
              <p>{contact.city}</p>
              <p>{COMPANY.country}</p>
            </div>
            <p className="mt-4 text-[#4A4A4A]">
              <span className="font-medium text-[#0A0A0A]">{l.representedByLabel}:</span> {l.representedBy}
            </p>
          </Reveal>

          <Reveal>
            <h2 className={h2}>{l.contactHeading}</h2>
            <div className="mt-4 space-y-1 text-[#4A4A4A]">
              <p>Tel: <a href={telHref(contact.phone)} className="hover:text-[#E8620E]">{contact.phone}</a></p>
              <p>E-Mail: <a href={mailHref(contact.email)} className="hover:text-[#E8620E]">{contact.email}</a></p>
              <p>Web: {contact.website}</p>
            </div>
          </Reveal>

          <Reveal>
            <h2 className={h2}>{l.registerHeading}</h2>
            <p className="mt-4 text-[#4A4A4A]">
              <span className="font-medium text-[#0A0A0A]">{l.uidLabel}:</span> {l.uid}
            </p>
          </Reveal>

          <Reveal>
            <h2 className={h2}>{l.disclaimerHeading}</h2>
            <p className="mt-4 leading-relaxed text-[#4A4A4A]">{l.disclaimer}</p>
          </Reveal>

          <Reveal>
            <h2 className={h2}>{l.copyrightHeading}</h2>
            <p className="mt-4 leading-relaxed text-[#4A4A4A]">{l.copyright}</p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
